import { IBillingAria, IBillingAriaEtab, IBillingAriaInvoice, IBillingAriaStatus } from "@core/models";

export const BillingAriaListMock = [
  {
    invoice: {
      [IBillingAriaInvoice.id]: "362 521 879",
      [IBillingAriaInvoice.date]: "2024-10-31",
      [IBillingAriaInvoice.amountTtc]: 100.0,
    },
    [IBillingAria.billingSessionId]: 123465,
    [IBillingAria.etab]: {
      [IBillingAriaEtab.id]: 123445, // ID BO
      [IBillingAriaEtab.name]: "Café de la gare",
      [IBillingAriaEtab.balance]: 100.0,
      [IBillingAriaEtab.authorizedAmount]: 500.0,
      [IBillingAriaEtab.remainingAmount]: 450.5,
      [IBillingAriaEtab.ariaUrl]: "http://www.fake-aria.fr",
      [IBillingAriaEtab.stripeUrl]: "http://www.fake-stripe.com",
    },
    [IBillingAria.ariaStatus]: {
      [IBillingAriaStatus.code]: "draft",
      [IBillingAriaStatus.color]: "primary",
      [IBillingAriaStatus.label]: "Brouillon",
      [IBillingAriaStatus.updatedAt]: "2024-10-31",
    },
    [IBillingAria.stripeStatus]: {
      [IBillingAriaStatus.code]: "in_progress",
      [IBillingAriaStatus.color]: "primary",
      [IBillingAriaStatus.label]: "Brouillon",
      [IBillingAriaStatus.updatedAt]: "2024-10-31",
    },
  },
  {
    invoice: {
      [IBillingAriaInvoice.id]: "362 521 880",
      [IBillingAriaInvoice.date]: "2024-11-01",
      [IBillingAriaInvoice.amountTtc]: 100.0,
    },
    [IBillingAria.billingSessionId]: 123466,
    [IBillingAria.etab]: {
      [IBillingAriaEtab.id]: 123445, // ID BO
      [IBillingAriaEtab.name]: "Café de la poste",
      [IBillingAriaEtab.balance]: 100.0,
      [IBillingAriaEtab.authorizedAmount]: 500.05,
      [IBillingAriaEtab.remainingAmount]: 400.0,
      [IBillingAriaEtab.ariaUrl]: "http://www.fake-aria.fr",
      [IBillingAriaEtab.stripeUrl]: "http://www.fake-stripe.com",
    },
    [IBillingAria.ariaStatus]: {
      [IBillingAriaStatus.code]: "in_progress",
      [IBillingAriaStatus.color]: "primary",
      [IBillingAriaStatus.label]: "Brouillon",
      [IBillingAriaStatus.updatedAt]: "2024-10-31",
    },
    [IBillingAria.stripeStatus]: {
      [IBillingAriaStatus.code]: "draft",
      [IBillingAriaStatus.color]: "primary",
      [IBillingAriaStatus.label]: "Brouillon",
      [IBillingAriaStatus.updatedAt]: "2024-10-31",
    },
  },
];

export const BillingAriaInvoiceSelectAll = {
  ids: [123465, 123466],
};
